import axios from "axios";
import { jwtDecode } from "jwt-decode";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

export const fetchBackupCodes = () => async (dispatch) => {
  dispatch({ type: "BACKUP_CODES_LOADING" });

  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const decodedToken = jwtDecode(token);
    const userGuid = decodedToken.userGuid;

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/generateBackupCode`,
        { userGuid },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (err) {
      if (err.response?.status !== 409) {
        throw err;
      }
    }

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth/listOfCodeViaUserGuid`,
      { userGuid },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    dispatch({
      type: "BACKUP_CODES_SUCCESS",
      payload: response.data.codes.map((c) => c.code),
    });
  } catch (err) {
    dispatch({
      type: "BACKUP_CODES_ERROR",
      payload: "An error occurred while fetching backup codes.",
    });
  }
};

export const rememberBackupDevice = () => async (dispatch, getState) => {
  const rememberDeviceCheck = getState().rememberDevice.rememberDeviceCheck;
  if (!rememberDeviceCheck) return;

  try {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const deviceId = result.visitorId;

    const token = JSON.parse(localStorage.getItem("token"));
    const decodedToken = jwtDecode(token);
    const userGuid = decodedToken.userGuid;

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/addRememberDevice`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ rememberDeviceCheck, deviceId, userGuid }),
      }
    );

    if (response.ok) {
      dispatch({ type: "BACKUP_REMEMBER_DEVICE_SUCCESS" });
    }
  } catch (error) {
    //console.error("Error saving device:", error);
  }
};

export const resetBackupCodesState = () => ({
  type: "BACKUP_CODES_RESET",
});
